var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('question-group',{attrs:{"headline":"Write"}},[_c('write-response',{attrs:{"model":_vm.blast.write,"respondable":_vm.blast.isOpen}}),_vm._v(" "),_c('review-display',{attrs:{"blast":_vm.blast}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc81910e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlastStudent/sidebar/write.vue
// module id = null
// module chunks = 